export const MonsterBrainIds = {
    /**
     * @constant
     * @type {string}
     */
    BASIC: 'B'
};